<template>
  <nav>
    <v-snackbar v-model="snackbar" :timeout="4000" top color="success">
      <span>{{info}}</span>
      <v-btn color="white" flat @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-toolbar flat app class="black pa-1" height="30">
      <v-toolbar-side-icon v-if="loggedIn" @click="drawer = !drawer" class="white"></v-toolbar-side-icon>
      <v-toolbar-title class="black--text" color="black">
        <v-icon large color="yellow">dynamic_feed</v-icon>
        <span class="white--text sub-headline">Munene J</span>
        <span class="red--text headline"> art</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn v-if="loggedIn" flat color="yellow" @click="$router.push('/projects')">
        <v-icon v-if="loggedIn" left>home</v-icon>
        <span v-if="loggedIn">Home</span>
      </v-btn>

      <!-- dropdown menu -->
      <v-menu v-if="loggedIn" offset-y>
        <v-btn v-if="loggedIn" flat slot="activator" color="yellow">
          <v-icon left>expand_more</v-icon>
          <span>Menu</span>
        </v-btn>
        <v-list>
          <v-list-tile v-for="link in links" :key="link.text" router :to="link.route">
            <v-list-tile-title>{{ link.text }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>

      <v-btn  flat color="white">
        <v-icon color="yellow" left>mail_outline</v-icon>
        <span>jmunene6@gmail.com</span>
      </v-btn>

      <v-btn v-if="!loggedIn" flat color="white">
        <v-dialog max-width="600px" v-model="indialog" color="black">
          <span slot="activator" flat right color="black">
            <v-icon right color="yellow">phone_callback</v-icon>
            <span>+254 725 804 404</span>
          </span>
          <v-card>
            <v-card-title class="pa-2 yellow">
              <h2>Existing Member Login Form</h2>
              <v-btn flat @click="outdialog=false">
                <v-icon>close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <v-form class="px-3" ref="form">
                <v-text-field
                  v-model="email1"
                  @click="error = false"
                  label="Email"
                  hint="name@organization.org"
                  prepend-icon="email"
                  :rules="inputRules"
                ></v-text-field>
                <v-text-field
                  v-model="password"
                  :append-icon="show1 ? 'visibility_off' : 'visibility'"
                  :rules="[rules.required, rules.min]"
                  :type="show1 ? 'text' : 'password'"
                  name="input-10-1"
                  label="Enter your password"
                  prepend-icon="lock"
                  hint="At least 8 characters"
                  counter
                  @click:append="show1 = !show1"
                ></v-text-field>
                <v-spacer></v-spacer>
                <v-btn flat @click="logUser" class="success mx-0 mt-3" :loading="loading">Log In</v-btn>
              </v-form>
              <v-alert v-if="error" color="red darken-3" :value="true" type="error">{{message}}</v-alert>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-btn>
    </v-toolbar>
    <v-navigation-drawer
      v-if="loggedIn"
      dark
      app
      v-model="drawer"
      style="top: 90px"
      class="grey darken-2"
    >
      <v-list class="white">
        <v-list-tile
          class="black"
          v-for="link in settings"
          :key="link.text"
          router
          :to="link.route"
        >
          <v-list-tile-action>
            <v-icon right class="blue--text">settings</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title class="white--text">Profile Settings</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-list class="grey darken-4" v-if="admin">
        <v-dialog max-width="600px" v-model="outdialog">
          <v-list-tile flat id="btn_add" slot="activator">
            <v-list-tile-action>
              <v-icon class="light-blue--text">person_add</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title class="light-blue--text">New Member</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-card>
            <v-card-title>
              <h2>Member Registration</h2>
            </v-card-title>
            <v-card-text>
              <v-form class="px-3" ref="regform">
                <v-alert v-if="success" color="success">{{message}}</v-alert>
                <v-text-field
                  v-model="orgname"
                  label="Organisation Name"
                  hint
                  prepend-icon="business"
                  :rules="inputRules"
                ></v-text-field>
                <v-text-field
                  v-model="email1"
                  label="Email"
                  hint="Your Email Address"
                  prepend-icon="email"
                  :rules="inputRules"
                ></v-text-field>
                <v-text-field
                  v-model="password1"
                  :append-icon="show1 ? 'visibility_off' : 'visibility'"
                  :rules="[rules.required, rules.min]"
                  :type="show1 ? 'text' : 'password'"
                  name="input-10-1"
                  label="Enter a password"
                  prepend-icon="lock"
                  hint="At least 8 characters"
                  counter
                  @click:append="show1 = !show1"
                ></v-text-field>
                <v-text-field
                  v-model="password2"
                  :append-icon="show1 ? 'visibility_off' : 'visibility'"
                  :rules="[rules.required, rules.min]"
                  :type="show1 ? 'text' : 'password'"
                  name="input-10-1"
                  label="Re-enter Password to confirm"
                  prepend-icon="lock"
                  hint="At least 8 characters"
                  counter
                  @click:append="show1 = !show1"
                ></v-text-field>
                <v-spacer></v-spacer>
              </v-form>
              <v-btn
                flat
                @click="registerUser"
                class="success mx-0 mt-3"
                :loading="loading"
              >Register</v-btn>
            </v-card-text>
          </v-card>
        </v-dialog>

        <v-list-tile v-for="link in adminlinks" :key="link.text" router :to="link.route">
          <v-list-tile-action>
            <v-icon class="light-blue--text">{{ link.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title class="light-blue--text">{{ link.text }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-list id="lastlist" class="grey darken-4">
        <v-divider class="grey"></v-divider>
        <v-list-tile v-for="link in links" :key="link.text" router :to="link.route">
          <v-list-tile-action>
            <v-icon class="blue--text">{{ link.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title class="white--text">{{ link.text }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider class="grey"></v-divider>
      </v-list>
    </v-navigation-drawer>
  </nav>
</template>

<script>
import { db, auth, functions, auth2, storage } from "@/fb";
import Popup from "./Popup";
import Register from "./register";
import Login from "./login";
import router from "../router.js";
import Footer from "./Footer";
import { constants } from "crypto";
const storageRef = storage.ref();

export default {
  components: {
    Popup,
    Register,
    Login,
    Footer
  },
  data() {
    return {
      success: false,
      message: "",
      error: false,
      userid: "",
      profileUrl: "",
      drawer: false,
      orgname: "",
      email: "",
      email1: "",
      password: "",
      password1: "",
      password2: "",
      userdata: [],
      name: "",
      //  pass: '',
      info: "",
      menu: false,
      admin: false,
      show1: false,
      logged: false,
      show2: false,
      rules: {
        required: value => !!value || "Required.",
        min: v => v.length >= 8 || "Min 8 characters",
        emailMatch: () => "The email and password you entered don't match"
      },
      inputRules: [
        v => !!v || "This field is required",
        v => v.length >= 3 || "Minimum length is 3 characters"
      ],
      passRules: [
        v => !!v || "This field is required",
        v => v.length >= 8 || "Minimum length is 8 characters"
      ],
      loading: false,
      indialog: false,
      loggedIn: false,
      links: [
        {
          icon: "euro",
          text: "Start Travel Business",
          route: "/business"
        },
        {
          icon: "card_membership",
          text: "Travel Membership Plans",
          route: "/projects"
        },
        {
          icon: "deck",
          text: "Become a DreamGiver",
          route: "/dreamgiver"
        },
        {
          icon: "video_library",
          text: "DreamTrips Explained",
          route: "/dreamtrips"
        },
        {
          icon: "video_library",
          text: "DreamTrips Website Demo",
          route: "/dashboard"
        }
      ],
      adminlinks: [
        { icon: "dashboard", text: "Dashboard", route: "/dashboard" },
        { icon: "group_add", text: "Administrators", route: "/admin" },
        { icon: "edit", text: "Participants", route: "/participant" },
        { icon: "assignment_ind", text: "Destinations", route: "/person" },
        {
          icon: "people_outline",
          text: "Travel Mate",
          route: "/prospect"
        },
        { icon: "local_library", text: "Vacation Offers", route: "/trainers" },
        { icon: "supervised_user_circle", text: "Travellers", route: "/team" }
      ],
      userlist: [
        { icon: "group_add", text: "Administrators", route: "/admin" }
      ],
      settings: [{ icon: "settings", text: "Update", route: "/profile" }],
      snackbar: false,
      outdialog: false
    };
  },
  created() {
    this.manageState();
    this.checkAuth();
    this.email1 = auth.currentUser.email;
  },

  methods: {
    logOut() {
      auth.signOut().then(() => {
        this.loggedIn = false;
        this.drawer = false;
        this.$router.go({ path: this.$router.path });
        this.admin = false;
      });
    },
    logIn() {
      this.loggedIn = true;
      this.logged = true;
    },
    logUser() {
      if (this.$refs.form.validate()) {
        this.loading = true;

        auth
          .signInWithEmailAndPassword(this.email1, this.password)
          .then(cred => {
            this.loggedIn = true;
            this.loading = false;
            this.indialog = false;
            this.drawer = true;
            this.success = true;
            this.error = false;
          })
          .catch(error => {
            // Handle Errors here.
            this.loading = false;
            this.success = false;
            this.error = true;
            var errorCode = error.code;
            var errorMessage = error.message;
            this.message = errorMessage;
            // ...
          });
      }
    },
    checkAuth() {
      //Check if user is an admin
      auth.onAuthStateChanged(user => {
        if (user) {
          this.profileURL();
          user.getIdTokenResult().then(idTokenResult => {
            if (idTokenResult.claims.admin == true) {
              this.admin = true;
            } else {
              this.admin = false;
            }
          });
        }
      });
    },
    manageState() {
      if (auth.currentUser) {
        this.loggedIn = true;
        this.loading = false;
        this.indialog = false;
        this.drawer = true;
      } else {
        this.drawer = false;
        this.loggedIn = false;
      }
    },
    registerUser() {
      if (this.$refs.regform.validate()) {
        if (this.password1 == this.password2) {
          auth
            .createUserWithEmailAndPassword(this.email1, this.password1)
            .then(() => {
              this.success = true;
              this.error = false;
              this.message = "Account Successfully Created";
              this.loggedIn = true;
              this.loading = false;
              this.indialog = false;
              this.outdialog = false;
              this.$router.push({ name: "projects" });
              this.userid = auth.currentUser.uid;
              console.log(this.userid);

              const prospects = {
                website: "",
                name: "",
                about: "",
                contactname: "",
                contactemail: "",
                contactphone: "",
                contactname1: "",
                contactemail1: "",
                contactphone1: "",
                photourl: "",
                userid: this.userid
              };
              db.collection("members")
                .add(prospects)
                .then(() => {
                  this.loading = false;
                  this.dialog = false;
                  this.success = true;
                  this.message = "User Created Successfully";
                });
            })
            .catch(function(error) {
              // Handle Errors here.
              this.error = true;
              this.success = false;
              var errorCode = error.code;
              var errorMessage = error.message;
              this.message = errorMessage;
              // ...
            });
        } else {
          this.error = true;
          this.success = false;
          this.message = "The Passwords entered do not match";
        }
      }
    },
    profileURL() {
      db.collection("members")
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            var idref = doc.id;
            if (doc.id == auth.currentUser.uid) {
              this.name = doc.data().name;
              this.profileUrl = doc.data().photourl;
            }
          });
        });
    }
  }
};
</script>

<style scoped>
#btn_add {
  margin-left: -10;
  padding: 0 8;
}

#lastlist {
  height: 350px;
  overflow-y: auto;
}
</style>
